import styled from "styled-components";
import { theme } from "@themes";

export const Carousel1 = styled.div`
  flex-shrink: 0;
  border-radius: 8px;
  max-width: 35%;
  max-height: 212px;
  .carousel-item {
    width: inherit;
  }
  .carousel-inner {
    border-radius: 8px;
  }
  .img {
    background-color: blue; /* Set the background color to blue */
    filter: blur(8px);
  }
  .custom-image-wrapper {
    border-radius: 8px;
    background: linear-gradient(
      356deg,
      rgba(48, 0, 49, 0.72) 86.68%,
      rgba(170, 0, 133, 0.28) 117.75%,
      rgba(176, 0, 180, 0) 133.28%
    );
    filter: blur(8px);
    overflow: hidden; /* Ensure the content does not overflow */
  }
  .custom-image-wrapper img {
    border-radius: 8px;
  }
`;

export const CustomCarousel = styled.div`
  .carousel-indicators li {
    background-color: ${({ theme }) => theme.neutral.black}; /* Change to the desired color for the circle */
    border-radius: 50%; /* Ensure the border-radius creates a circular shape */
    width: 10px; /* Adjust width as necessary */
    height: 10px; /* Adjust height as necessary */
  }
  .carousel-inner {
    border-radius: 8px;
  }
`;
export const CarouselItem = styled.div`
  position: absolute;
  width: 320px;
  right: 5%;
  bottom: 2.5rem;
  left: -7%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: ${({ theme }) => theme.neutral.white};
  text-align: center;

  .text1 {
    text-align: left;
    color: ${({ theme }) => theme.neutral.white};
    font-size: 1.375rem;
    font-weight: 700;
    line-height: normal;
    margin-bottom: 40px;
  }

  .text2 {
    margin-top: 15px;
    color: ${({ theme }) => theme.neutral.white};
    text-align: left;
    font-size: 1.5625rem;
    font-weight: 700;
    line-height: normal;
  }

  .text3 {
    color: ${({ theme }) => theme.neutral.white};
    margin-top: 6px;
    text-align: left;
    font-size: 1.125rem;
    font-weight: 300;
    line-height: normal;
  }
`;

export const CarouselItem1 = styled.div`
  position: absolute;
  width: 320px;
  right: 5%;
  bottom: 3.5rem;
  left: -7%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: ${({ theme }) => theme.neutral.white};
  text-align: center;

  .text1 {
    text-align: left;
    color: ${({ theme }) => theme.neutral.white};
    font-size: 1.375rem;
    font-style: normal;
    font-weight: 800;
    line-height: normal;
  }

  .text2 {
    margin-top: 10px;
    text-align: left;
    color: ${({ theme }) => theme.neutral.white};
    font-size: 1.25rem;
    font-style: normal;
    font-weight: 500;
    line-height: 25px; /* 125% */
    color: ${({ theme }) => theme.neutral.white};
    font-style: normal;
    line-height: 25px;
  }
`;
export const Button1 = styled.div`
  display: flex;
  width: 163px;
  height: 26px;
  padding: 11px 32px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.neutral.white};
  .button1 {
    color: ${({ theme }) => theme.neutral.white};
    text-align: center;
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
`;

export const Button = styled.div`
  display: flex;
  width: 121px;
  height: 26px;
  padding: 11px 32px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.neutral.white};
  margin-left: -21px;
  cursor: pointer;
  .button {
    color: ${({ theme }) => theme.neutral.white};
    text-align: center;
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
`;

export const CarouselItem2 = styled.div`
  position: absolute;
  width: 220px;
  right: 5%;
  bottom: 1.5rem;
  left: -7%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: ${({ theme }) => theme.neutral.white};
  text-align: center;
  .text1 {
    text-align: left;
    width: 210.393px;
    color: ${({ theme }) => theme.neutral.white};
    font-size: 1.375rem;
    font-style: normal;
    font-weight: 700;
    line-height: 24px; /* 109.091% */
  }
  .text2 {
    margin-top: 10px;
    width: 236.214px;
    color: ${({ theme }) => theme.neutral.white};
    text-align: left;
    font-size: 1rem;
    font-style: normal;
    font-weight: 400;
    line-height: 18px; /* 112.5% */
  }
`;
export const CircleButton = styled.div`
  position: relative;
  width: 138px;
  height: 120px;
  margin-left: 227px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  filter: drop-shadow(0px 0px 15px ${({ theme }) => theme.shadows.strong});
`;
export const HelpButton = styled.span`
  position: absolute;
  color: ${({ theme }) => theme.neutral.white};
  text-align: center;
  font-size: 2rem;
  font-style: normal;
  font-weight: 700;
  line-height: 12px; /* 37.5% */
`;
